
import { HttpClientModule } from '@angular/common/http';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPaginationModule } from 'ngx-pagination';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { CardItineraryComponent } from './card-itinerary/card-itinerary.component';
import { DataItineraryComponent } from './data-itinerary/data-itinerary.component';
import { PriceItineraryComponent } from './price-itinerary/price-itinerary.component';
import { ItemDetailsComponent } from './card-itinerary/item-details/item-details.component';
import { ItemStatusComponent } from './card-itinerary/item-status/item-status.component';
import { ItineraryDetailComponent } from './itinerary-detail.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { FlightModalComponent } from 'app/shared/flight-modal/flight-modal.component';
import { ItineraryDetailRoutingModule } from './itinerary-detail-routing.module';


@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        NgxPaginationModule,
        ModalModule.forRoot(),
        CarouselModule,
        TabsModule.forRoot(),
        BrowserAnimationsModule,
        FormsModule,
        NgxSpinnerModule,
        SharedModule,
        HttpClientModule,
        AngularSvgIconModule,
        ItineraryDetailRoutingModule,
        TooltipModule
    ],
    declarations: [
        ItineraryDetailComponent,
        CardItineraryComponent,
        DataItineraryComponent,
        PriceItineraryComponent,
        ItemDetailsComponent,
        ItemStatusComponent,
    ],
    exports: [
      ItineraryDetailComponent
    ],
    entryComponents: [
      FlightModalComponent
    ]
})
export class ItineraryDetailModule { }
